const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error'
};
/* Load french images 
document.addEventListener('DOMContentLoaded', function () {
  const isFrenchLocale = window.location.pathname.toLowerCase().startsWith('/fr-fr');
console.log(isFrenchLocale);
  if (isFrenchLocale) {

    // First slide desktop image
    const desktopImg5 = document.querySelector('.banner__media.media.small-hide img');
    if (desktopImg5) {
      desktopImg5.src = 'https://cdn.shopify.com/s/files/1/0528/3748/2646/files/ultimate-golf-desktop-fr.webp?v=1758621253';
      desktopImg5.srcset = '';
    }

   // First slide mobile image
    const mobileImg5 = document.querySelector('.banner__media.media.medium-hide.large-up-hide img');
    if (mobileImg5) {
      mobileImg5.src = 'https://cdn.shopify.com/s/files/1/0528/3748/2646/files/ultimate-golf-mobile-fr.webp?v=1758621254';
      mobileImg5.srcset = '';
    }



    // First slide desktop image
    const desktopImg1 = document.querySelector('.slideshow.banner > div:nth-of-type(1) img.small-hide');
    if (desktopImg1) {
      desktopImg1.src = 'https://cdn.shopify.com/s/files/1/0528/3748/2646/files/ultimate-golf-desktop-fr.webp?v=1758621253';
      desktopImg1.srcset = '';
    }
 
    // First slide mobile image
    const mobileImg1 = document.querySelector('.slideshow.banner > div:nth-of-type(1) img.medium-hide.large-up-hide');
    if (mobileImg1) {
      mobileImg1.src = 'https://cdn.shopify.com/s/files/1/0528/3748/2646/files/ultimate-golf-mobile-fr.webp?v=1758621254';
      mobileImg1.srcset = '';
    }

    // Second slide desktop image
    const desktopImg2 = document.querySelector('.slideshow.banner > div:nth-of-type(2) img.small-hide');
    if (desktopImg2) {
      desktopImg2.src = 'https://cdn.shopify.com/s/files/1/0528/3748/2646/files/ultimate-golf-desktop-fr.webp?v=1758621253';
      desktopImg2.srcset = '';
    }

    // Second slide mobile image
    const mobileImg2 = document.querySelector('.slideshow.banner > div:nth-of-type(2) img.medium-hide.large-up-hide');
    if (mobileImg2) {
      mobileImg2.src = 'https://cdn.shopify.com/s/files/1/0528/3748/2646/files/ultimate-golf-mobile-fr.webp?v=1758621254';
      mobileImg2.srcset = '';
    }
  }
});
*/